export const GROWTH_MAP_PACK_META = {
  eyebrow: 'SEO · Google Business Profile',
  titleLead: 'Local Map Pack',
  titleAccent: 'intelligence',
  description:
    'Compare your Google Business Profile performance, reputation momentum, and local visibility against your top competitors.',
  competitorName: 'Smile Central',
  benchmarkInsight:
    'Smile Central is winning 10 of 10 GBP metrics. Your strongest relative position is Star Rating (4.6 vs 4.8 — only a 0.2 gap). Your biggest gap is review volume (-265 behind).',
  profileGapNote:
    "You're missing 6 profile elements that Smile Central has completed. Biggest gaps: zero photos in 90 days, no active offers, and an empty Q&A section. These directly affect your Map Pack ranking.",
  reviewAuditNote:
    'Replying to all 14 unanswered reviews would lift your response rate from 65% to about 90% — matching Smile Central. Prioritize the 3 negative reviews first; prospective patients read those first.',
  aiBriefBottomLine:
    "You have a strong foundational rating (4.6), but Smile Central is out-pacing you in sheer volume (+12 reviews this month vs your +4) and profile activity, securing their #1 spot. You're winning zero benchmark metrics — but the gap is closeable within 90 days with consistent execution.",
  footerDataNote: 'GBP data refreshed daily · sentiment from latest 100 reviews per competitor',
  footerBenchmarkNote: 'Benchmarked against 8 local competitors',
} as const;
